import type { FC } from 'react';

import { ArArkoseProtectedFormBlock } from '../sites/ar/components/ArArkoseProtectedFormBlock';
import { ArDownloadFormBlock } from '../sites/ar/components/ArDownloadForm';
import { ArDownloadIdCaptureBlock } from '../sites/ar/components/ArDownloadIdCapture';
import { ArDownloadLinkCard } from '../sites/ar/components/ArDownloadLinkCard/ArDownloadLinkCard';
import { ArLinkOutsBlock } from '../sites/ar/components/ArLinkOutsBlock/ArLinkOutsBlock';
import { AvalonDeepLinkBlock } from '../sites/avalon/components/AvalonDeepLinkBlock/AvalonDeepLinkBlock';
import { AvalonFormBlock } from '../sites/avalon/components/AvalonFormBlock/AvalonFormBlock';
import { AvalonHomeHero } from '../sites/avalon/components/AvalonHomeHero/AvalonHomeHero';
import { AvalonProductHero } from '../sites/avalon/components/AvalonProductHero/AvalonProductHero';
import { AvalonScrollSection } from '../sites/avalon/components/AvalonScrollSection/AvalonScrollSection';
import { FixedPositionBlock } from '../sites/avalon/components/FixedPositionBlock/FixedPositionBlock';
import { MosaicGridBlock } from '../sites/avalon/components/MosaicGridBlock/MosaicGridBlock';
import { ValuePropsBlock } from '../sites/avalon/components/ValuePropsBlock/ValuePropsBlock';
import { JobApplyNowBlock } from '../sites/careers/components/JobApplyNowBlock/JobApplyNowBlock';
import { JobDescriptionBlock } from '../sites/careers/components/JobDescriptionBlock/JobDescriptionBlock';
import { JobHero } from '../sites/careers/components/JobHero/JobHero';
import { JobMobileCallToAction } from '../sites/careers/components/JobMobileCallToAction/JobMobileCallToAction';
import { JobPostingsShallow } from '../sites/careers/components/JobsPostings/JobPostingsShallow';
import { CheeriosBlock } from '../sites/cheerios/components/CheeriosBlock';
import { CheeriosStaticBlock } from '../sites/cheerios/components/CheeriosStaticBlock';
import { AiAgent } from '../sites/creators/components/AiAgent/AiAgent';
import { CventAuthenticator } from '../sites/experience/components/CventAuthenticator/CventAuthenticator';
import { EventRoot } from '../sites/experience/components/LiveEvent/EventRoot';
import { RegistrationFormBlock } from '../sites/experience/components/RegistrationFormBlock/RegistrationFormBlock';
// eslint-disable-next-line max-len
import { Sps2024ConfirmationShallow as ExperienceSps2024ConfirmationShallow } from '../sites/experience/components/Sps2024Confirmation/Sps2024ConfirmationShallow';
// eslint-disable-next-line max-len
import { Sps2024RegistrationShallow as ExperienceSpsRegistrationShallow } from '../sites/experience/components/Sps2024Registration/Sps2024RegistrationShallow';
import { ZkipsterAuthenticator } from '../sites/experience/components/ZkipsterAuthenticator/ZkipsterAuthenticator';
import { ChiliPiperFormBlockShallow } from '../sites/for-business/components/ChiliPiperForm/ChiliPiperFormShallow';
import { LeadGenFormBlock } from '../sites/for-business/components/LeadGenForm/LeadGenFormBlock';
import { LatestGalleryCardHeroShallow } from '../sites/newsroom/components/LatestGalleryCardHero/LatestGalleryCardHeroShallow';
import { CookieTestBlock } from '../sites/sandbox/components/CookieTestBlock/CookieTestBlock';
import { CookieInformationBlock } from '../sites/snap/components/CookieInformationBlock/CookieInformationBlock';
import { SnapHomePage } from '../sites/snap/pages/SnapHomePage';
import { SnapHomePageV2 } from '../sites/snap/pages/SnapHomePageV2';
// Temporary will have a follow up PR to make standard component.
import { StinsonRevealHome } from '../sites/stinson/pages/stinsonRevealHome/StinsonRevealHome';
import { QuestionnaireBlock } from './QuestionnaireBlock';

/**
 * Returns a map of all supported custom components.
 *
 * This is in a separate file and not Site Config because adding it there introduces a circular
 * dependency because usually you can't instantiate custom components without backreferencing the
 * Config in some way.
 */
export function getCustomComponents(): Record<string, FC<{ id: string }>> {
  return {
    AiAgent,
    ArDownloadFormBlock,
    ArDownloadIdCaptureBlock,
    ArDownloadLinkCard,
    ArLinkOutsBlock,
    AvalonHomeHero,
    AvalonDeepLinkBlock,
    AvalonProductHero,
    AvalonFormBlock,
    AvalonScrollSection,
    FixedPositionBlock,
    ValuePropsBlock,
    CheeriosBlock,
    CheeriosStaticBlock,
    ChiliPiperFormBlock: ChiliPiperFormBlockShallow,
    CookieInformationBlock,
    JobApplyNowBlock,
    JobDescriptionBlock,
    JobHero,
    JobPostings: JobPostingsShallow,
    JobMobileCallToAction,
    QuestionnaireBlock,
    SandboxCookieTest: CookieTestBlock,
    LatestGalleryCardHero: LatestGalleryCardHeroShallow,
    RegistrationFormBlock,
    ArArkoseProtectedFormBlock,
    LeadGenFormBlock,
    ExperienceSps2024Registration: ExperienceSpsRegistrationShallow,
    ExperienceSps2024Confirmation: ExperienceSps2024ConfirmationShallow,
    CventAuthenticator,
    ZkipsterAuthenticator,
    MosaicGridBlock,
    LiveEvent: EventRoot,
    SnapHomePage,
    SnapHomePageV2,
    StinsonRevealHome,
  };
}
